import * as React from 'react';
import { MenuTriggerContextProvider } from '../../contexts/menuTriggerContext';
/**
 * Render the final JSX of MenuTrigger
 *
 * Only renders children
 */ export const renderMenuTrigger_unstable = (state)=>{
    return /*#__PURE__*/ React.createElement(MenuTriggerContextProvider, {
        value: state.isSubmenu
    }, state.children);
};
